export class DeleteSocialNetworkSuccess {
    static readonly type = '[User] DeleteSocialNetworkSuccess';
}
